React = require 'react'
Util = require 'lib/util'
t = require('views/internal/recup-with-helpers')('home')

module.exports = class HomeNewUserComponent extends React.Component
  displayName: 'HomeNewUserComponent'

  constructor: (props) ->
    super props

    @onCreateBoardClick = @onCreateBoardClick.bind(@)
    @onInputChange = @onInputChange.bind(@)

    @state = {
      boardName: ''
    }

  onInputChange: (e) ->
    Util.preventDefault(e)
    @setState boardName: e.target.value

  onCreateBoardClick: (e) ->
    Util.preventDefault(e)
    # TODO: Track

    name = @state.boardName.trim()
    if name == ''
      @input.focus()
      return

    @props.onCreateBoardClick(name)

  render: t.renderable ->
    { title, text, backgroundClass, onDismissClick } = @props

    t.div '.home-orientation-container.background-top', =>
      t.div ".home-orientation-background.background-top.#{backgroundClass}"
      t.div '.home-orientation-info-container', =>
        t.span '.home-orientation-title', ->
          t.format title
        t.span '.home-orientation-info-text', ->
          t.format text

        t.input '.home-orientation-create-board-input', {
          id: 'newUserCreateBoard'
          type: 'text'
          placeholder: t.l('orientation-create-board-input')
          onChange: @onInputChange
          value: @state.boardName
          ref: (input) =>
            input && input.focus()
            @input = input
        }
        t.a '.button.primary.home-orientation-create-board-button', onClick: @onCreateBoardClick, ->
          t.format 'orientation-create-board-button'

        if onDismissClick
          t.a '.home-orientation-dismiss.background-top.quiet', { onClick: onDismissClick }, ->
            t.format 'orientation-dismiss'



// WEBPACK FOOTER //
// ./app/scripts/views/home/home-new-user-component.coffee